import { BootstrapApi, ReachAPI, WidgetCacheApi } from './index'

export const createEmbed = (locale) => {
  return WidgetCacheApi.post('/child_embeds', locale)
}

export const patchSpecficEmbed = (embedId, operations) => {
  return WidgetCacheApi.patch(`/child_embeds/${embedId}`, operations)
}

export const fetchMultiEmbeds = () => {
  return WidgetCacheApi.get('/child_embeds')
}

// targeting for embeds

export const fetchAllEmbedTargeting = () => {
  return BootstrapApi.get('/data/embed-targeting/bulk')
}

export const updateEmbedTargeting = ({ embedId, payload }) => {
  return BootstrapApi.patch(`data/embed-targeting/${embedId}`, payload)
}

export const createEmbedTargeting = ({ payload }) => {
  return BootstrapApi.post('data/embed-targeting', payload)
}

export const getInactiveUrls = ({ payload }) => {
  return ReachAPI.post('/url/inactive', payload)
}
